import { Column, DataType, Model, Table, ForeignKey, BelongsTo } from 'sequelize-typescript'
import { Sequelize } from 'sequelize'

import { PlataformaModel } from './plataforma.model'

@Table({
  freezeTableName: true,
  modelName: 'cuenta',
  timestamps: false,
})
export class CuentaModel extends Model {
  @ForeignKey(() => PlataformaModel)
  @Column({
    type: DataType.INTEGER,
    allowNull: false,
  })
  plataformaId!: number

  @Column({
    type: DataType.STRING(60),
    allowNull: false,
  })
  nombre!: number

  @Column({
    type: DataType.TEXT,
    allowNull: false,
  })
  identificador: string

  @Column({
    type: DataType.TEXT,
    allowNull: true,
  })
  identificadorPadre: string

  @Column({
    type: DataType.STRING(60),
    allowNull: false,
  })
  dominio!: string

  @Column({
    type: DataType.CHAR(128),
    allowNull: false,
    comment: 'identificador entre aplicaciones internas o externas de clientes',
  })
  apiKey!: string

  @Column({
    type: DataType.TEXT,
    allowNull: false,
    comment: 'Se utiliza ya sea un accesToken o apiKey con los proveedores de servicios y/o plataformas directamente',
  })
  token!: string

  @Column({
    type: DataType.STRING,
    allowNull: false,
    comment: 'Este campo indica a que endpoint redireccionará la data procesada',
  })
  redirect!: string

  @Column({
    type: 'timestamp',
    defaultValue: Sequelize.literal('CURRENT_TIMESTAMP'),
    allowNull: false,
  })
  capturaFecha!: Date

  @BelongsTo(() => PlataformaModel)
  plataforma!: PlataformaModel
}
